// extracted by mini-css-extract-plugin
module.exports = {"updateActionButton":"EditMsgPromoCodeForm_updateActionButton__20-Ft","editPromoCodeLayoutBackground":"EditMsgPromoCodeForm_editPromoCodeLayoutBackground__tLJSW"};